@if (columns.length > 0) {
  <app-tree-table
    (focusDateChange)="focusDateChange($event)"
    [actionColumnWidth]="350"
    [columns]="columns"
    [createLabels]="[
      'CUSTOMERS.CREATE_CUSTOMER',
      'CUSTOMERS.CREATE_CUSTOMER_CASE',
      'CUSTOMERS.CREATE_CUSTOMER_CASE_MUTATION',
    ]"
    [editable]="isTableEditable()"
    [firstColumnFrozen]="true"
    [focusDate]="focusDate"
    [hasFocusDate]="true"
    [headerGroups]="headerGroupColumns"
    [lazy]="true"
    [strictFilterMode]="false"
    [value]="tree"
    #treeTable
    dataKey="customerId"
    sortField="customerId"></app-tree-table>
}
